module.exports = __webpack_public_path__ + "img/logo.e4133ec6.svg";